import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { styled } from '@mui/system';
import Spinner from '@components/Icons/Spinner';
const useStyles = makeStyles()((theme) => {
    return {
        core: {
            alignItems: 'center',
            display: 'inline-flex',
            fontFamily: theme.typography.fontFamily,
            justifyContent: 'center',
            backgroundColor: 'rgb(255,255,255)',
            width: '200px',
            height: '35px',
            border: `1px solid ${theme.palette.grey[200]}`,
            '&:hover, &:active, &:focus': {
                filter: 'brightness(0.95)',
            },
        },
    };
});
const StyledLoadingSpinner = styled(Spinner) `
  font-size: 15px;
  width: 1.2em;
  height: 1.2em;
`;
const AuthorizeNetButton = React.forwardRef(({ className = undefined, id = undefined, type = 'button', disabled = false, loading = false, ariaLabel = undefined, testId = undefined, onClick = undefined, }, ref) => {
    const { classes, cx } = useStyles({ variant: 'primary' });
    const classNames = cx(classes.core, className);
    return (_jsx("button", { ref: ref, className: classNames, type: type, id: id, disabled: disabled, "aria-label": ariaLabel, "data-testid": testId, onClick: onClick, children: loading ? (_jsx(StyledLoadingSpinner, { title: "loading" })) : (_jsx("img", { width: 120, src: "/img/authorize-net.svg", alt: "AuthorizedNet" })) }));
});
export default AuthorizeNetButton;
